// import React from 'react';
// import { 
//   FileCheck2, ShieldCheck, Scale, Landmark, 
//   UserCheck, History, Building2, FileText, 
//   FileSignature, CheckCircle, Smartphone 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function DocumentationServices() {
  
//   // The official notarization services the firm offers
//   const notarizationServices = [
//     {
//       title: "إصدار وفسخ الوكالات الشرعية",
//       desc: "توثيق كافة أنواع الوكالات للأفراد والشركات (العامة، الخاصة، القضائية، والمالية) وإلغائها فوراً بشكل مرن ونظامي.",
//       icon: <UserCheck className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "توثيق عقود التأسيس والملاحق",
//       desc: "المصادقة الرسمية على عقود تأسيس الشركات بمختلف أنواعها، وقرارات ذوي العلاقة، وملاحق التعديل ودخول الشركاء الجدد.",
//       icon: <Building2 className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "الإفراغ والتوثيق العقاري",
//       desc: "نقل ملكية العقارات، الأراضي، والمخططات، وفك ورهن العقارات التجارية والسكنية وإصدار الصكوك المحدثة مباشرة.",
//       icon: <FileSignature className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "توثيق الإقرارات المالية والديون",
//       desc: "إثبات وتوثيق الإقرارات بالمديونية، التنازل عن الحقوق، استلام المبالغ المالية، والإبراءات ذات الحجية القانونية المطلقة.",
//       icon: <FileText className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-white text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="خدمات التوثيق  القانوني"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1450133064473-71024230f91b?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">خدمات التوثيق المعتمدة برخصة وزارة العدل</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">خدمات التوثيق  القانوني</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نحن نوفر وقتك وجهدك عبر تقديم خدمات التوثيق الرسمي والمعتمد لكافة معاملاتك العقارية، الشركاتية، والشخصية بمرونة تامة وبصلاحيات كاملة مماثلة لكتابات العدل الرسمية في المملكة.
//           </p>
//         </div>
//       </section>

//       {/* Speed & Digital Ecosystem Focus */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-6 leading-tight">
//               أعمالك لا تنتظر المواعيد الحكومية
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed mb-4">
//               بصفتنا جهة توثيق مرخصة ومعتمدة من وزارة العدل السعودية، نمتلك الصلاحية النظامية لتوثيق عقودك وإقراراتك وإصدار صكوكك العقارية والوكالات في أي وقت، سواء داخل مقر مكتبنا في جدة أو في موقع منشأتك.
//             </p>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               تتم العملية بالكامل بطريقة رقمية متكاملة مرتبطة مباشرة بالأنظمة الإلكترونية لوزارة العدل، وتصدر المستندات فوراً ويتم تفعيلها على منصة (ناجز) للعملاء خلال دقائق معدودة مع الحفاظ التام على السرية والأمان المعلوماتي.
//             </p>
//           </div>
          
//           {/* Why Document with Us feature box */}
//           <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 space-y-6">
//             <h3 className="text-xl font-bold text-slate-800 mb-2 flex items-center gap-2">
//               <ShieldCheck className="w-5 h-5 text-amber-600" /> مزايا التوثيق عبر مكتبنا:
//             </h3>
            
//             <div className="flex gap-3 items-start">
//               <CheckCircle className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**مرونة مطلقة:** إمكانية تقديم خدمات التوثيق في أوقات خارج الدوام الرسمي وعطلات نهاية الأسبوع.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <CheckCircle className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**حجية قطعية:** جميع المحررات الصادرة تحمل صفة السند التنفيذي المباشر أمام محاكم التنفيذ.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <CheckCircle className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**سرعة التنفيذ:** تفادي فترات الانتظار الطويلة وحجز المواعيد في كتابات العدل الحكومية العامة.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Core Services Matrix Breakdown */}
//       <section className="bg-slate-900 text-white py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold mb-3">نطاق خدمات التوثيق والمصادقة الشرعية</h2>
//             <p className="text-slate-400 max-w-xl mx-auto">حلول توثيق سريعة وآمنة تدعم التدفق القانوني السلس لاستثماراتك اليومية</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {notarizationServices.map((service, index) => (
//               <div key={index} className="bg-slate-800/60 p-8 rounded-xl border border-slate-700 hover:border-amber-500 transition-all duration-300">
//                 <div className="bg-slate-700/50 p-3 rounded-lg w-fit mb-5">
//                   {service.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-100 mb-2">{service.title}</h3>
//                 <p className="text-slate-400 text-sm leading-relaxed">{service.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Integration Framework Process (Seamless Integration with Najiz / Absher) */}
//       <section className="max-w-4xl mx-auto py-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-amber-50 rounded-full text-amber-700 mb-4">
//           <Smartphone className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">متطلبات إنهاء التوثيق الفوري</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           تتم كافة عمليات المصادقة والتوثيق من خلال التحقق الرقمي المباشر عبر منصة **النفاذ الوطني الموحد (أبشر)**، مما يتطلب حضور أصحاب العلاقة أو تفعيل حساباتهم الرقمية لاستقبال رسائل تأكيد وزارة العدل والمصادقة الفورية على المستندات.
//         </p>
//         <div className="flex justify-center gap-4">
//           <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md">
//             احجز موعد توثيق عاجل
//           </button>
//         </div>
//       </section>

//     </div>
//   );
// }

import React from 'react';
import { 
  FileCheck2, ShieldCheck, Scale, Landmark, 
  UserCheck, History, Building2, FileText, 
  FileSignature, CheckCircle, Smartphone 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';
import { openWhatsApp } from '../utils';

export default function DocumentationServices() {
  
  // The official notarization services the firm offers - Refactored to Navy Light
  const notarizationServices = [
    {
      title: "إصدار وفسخ الوكالات الشرعية",
      desc: "توثيق كافة أنواع الوكالات للأفراد والشركات (العامة، الخاصة، القضائية، والمالية) وإلغائها فوراً بشكل مرن ونظامي.",
      icon: <UserCheck className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "توثيق عقود التأسيس والملاحق",
      desc: "المصادقة الرسمية على عقود تأسيس الشركات بمختلف أنواعها، وقرارات ذوي العلاقة، وملاحق التعديل ودخول الشركاء الجدد.",
      icon: <Building2 className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "الإفراغ والتوثيق العقاري",
      desc: "نقل ملكية العقارات، الأراضي، والمخططات، وفك ورهن العقارات التجارية والسكنية وإصدار الصكوك المحدثة مباشرة.",
      icon: <FileSignature className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "توثيق الإقرارات المالية والديون",
      desc: "إثبات وتوثيق الإقرارات بالمديونية، التنازل عن الحقوق، استلام المبالغ المالية، والإبراءات ذات الحجية القانونية المطلقة.",
      icon: <FileText className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="خدمات التوثيق القانوني"
        description="نقدم خدمات توثيق رسمية معتمدة تدعم التدفق القانوني السلس لأعمالك واستثماراتك"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1450133064473-71024230f91b?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for modern executive contrast */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">خدمات التوثيق المعتمدة برخصة وزارة العدل</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">خدمات التوثيق القانوني</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نحن نوفر وقتك وجهدك عبر تقديم خدمات التوثيق الرسمي والمعتمد لكافة معاملاتك العقارية، الشركاتية، والشخصية بمرونة تامة وبصلاحيات كاملة مماثلة لكتابات العدل الرسمية في المملكة.
          </p>
        </div>
      </section>

      {/* Speed & Digital Ecosystem Focus */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              أعمالك لا تنتظر المواعيد الحكومية
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              بصفتنا جهة توثيق مرخصة ومعتمدة من وزارة العدل السعودية، نمتلك الصلاحية النظامية لتوثيق عقودك وإقراراتك وإصدار صكوكك العقارية والوكالات في أي وقت، سواء داخل مقر مكتبنا أو في موقع منشأتك.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              تتم العملية بالكامل بطريقة رقمية متكاملة مرتبطة مباشرة بالأنظمة الإلكترونية لوزارة العدل، وتصدر المستندات فوراً ويتم تفعيلها على منصة (ناجز) للعملاء خلال دقائق معدودة مع الحفاظ التام على السرية والأمان المعلوماتي.
            </p>
          </div>
          
          {/* Why Document with Us feature box - Navy Light Theme */}
          <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200/60 space-y-6 shadow-sm">
            <h3 className="text-xl font-bold text-indigo-950 mb-2 flex items-center gap-2">
              <ShieldCheck className="w-5 h-5 text-blue-700" /> مزايا التوثيق عبر مكتبنا:
            </h3>
            
            <div className="flex gap-3 items-start">
              <CheckCircle className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="font-bold text-indigo-950">مرونة مطلقة:</strong> إمكانية تقديم خدمات التوثيق في أوقات خارج الدوام الرسمي وعطلات نهاية الأسبوع.</p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="font-bold text-indigo-950">حجية قطعية:</strong> جميع المحررات الصادرة تحمل صفة السند التنفيذي المباشر أمام محاكم التنفيذ.</p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="font-bold text-indigo-950">سرعة التنفيذ:</strong> تفادي فترات الانتظار الطويلة وحجز المواعيد في كتابات العدل الحكومية العامة.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Services Matrix Breakdown - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">نطاق خدمات التوثيق والمصادقة الشرعية</h2>
            <p className="text-slate-500 max-w-xl mx-auto text-sm md:text-base font-light">حلول توثيق سريعة وآمنة تدعم التدفق القانوني السلس لاستثماراتك اليومية</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {notarizationServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{service.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Integration Framework Process - Refactored Styles */}
      <section className="max-w-4xl mx-auto py-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <Smartphone className="w-6 h-6" />
        </div>
        <h3 className="text-xl font-bold text-indigo-950 mb-2">متطلبات إنهاء التوثيق الفوري</h3>
        <p className="text-slate-500 text-sm max-w-xl mx-auto mb-6 font-light">
          تتم كافة عمليات المصادقة والتوثيق من خلال التحقق الرقمي المباشر عبر منصة <strong className="font-semibold text-indigo-950">النفاذ الوطني الموحد (أبشر)</strong>، مما يتطلب حضور أصحاب العلاقة أو تفعيل حساباتهم الرقمية لاستقبال رسائل تأكيد وزارة العدل والمصادقة الفورية على المستندات.
        </p>
        <div className="flex justify-center gap-4">
          <button
          onClick={() => openWhatsApp( "   احجز موعد توثيق عاجل  ")}
          
          className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm">
            احجز موعد توثيق عاجل
          </button>
        </div>
      </section>

    </div>
  );
}